// --- React
import React from 'react';
// --- UI Components
import { Col, Row } from 'antd';
import Typography from '@dtci/spellbook/Typography';
// --- Custom Components & Utilities
import { getMetadataDetails, MetadataTables } from '../utils/getDetailsData';
// --- Styles
import '../../styles.scss';

/**
 * MetadataCard Component
 *
 * This component is responsible for rendering a card that displays detailed
 * metadata information about a product.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.details - The details of the product to be displayed.
 * @returns {JSX.Element} Metadata card with detailed information.
 **/
export function MetadataCard({ details }) {
    // Function to extract metadata details from the provided data
    const metadataDetails = getMetadataDetails(details);

    return (
        <>
            <Row style={{ marginTop: 20 }}>
                <Col>
                    {metadataDetails.map(({ label, value }, idx) => (
                        <Row key={`meta-${idx}`}>
                            <Typography variant="T20">
                                <b>{label}:</b>
                                <br />
                                {value}
                            </Typography>
                        </Row>
                    ))}
                </Col>
            </Row>

            <div>
                <MetadataTables details={details} />
            </div>
        </>
    );
}
